import { Block } from "baseui/block";
import { themedUseStyletron } from "../../../theme/customTheme";
import { OperationHours } from "../Aggregate/OperationHours";
import { IDriveThreeSpeed } from "./types";
import { LastXDaysLabel } from "../SensorDigital/LastXDaysLabel";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";
import GenericTimeline, { TGenericTimelineEvent, TGenericTimelineLabel } from "../../../components/Charts/GenericTimeline/GenericTimeline";
import { HistoricalDataItem, useGetByIdAndTimeQuery } from "../../../services/historicalData";
import { useMemo } from "react";
import { useStyletron } from "baseui";
import { GenericTimeseriesStatistics } from "../../../components/Charts/GenericTimeseriesStatistics";
import { useIntl } from "react-intl";


const InsightsPanel = (props: IDriveThreeSpeed) => {
    const [css, theme] = themedUseStyletron()

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    return (<>
        {props.operationHours > 0 && <OperationHours {...props}></OperationHours>}
        <Block marginTop={theme.sizing.scale800}></Block>
        <LastXDaysLabel days={7}></LastXDaysLabel>
        <DriveThreeSpeedTimeline {...props} start={timeRange.start} end={timeRange.end}></DriveThreeSpeedTimeline>
    </>)
}

export default InsightsPanel


// TODO - we should add a actState Enum to the drive and set in depending on properties 
// then use that value here so we need only on call and no data mapping
const DriveThreeSpeedTimeline = (props: any) => {
    const [, theme] = useStyletron()
    const intl = useIntl();
    const labels: TGenericTimelineLabel[] = [
        { label: intl.formatMessage({ id: "Devices.OFF", defaultMessage: "OFF" }), color: theme.colors.backgroundTertiary, value: 0 },
        { label: intl.formatMessage({ id: "Devices.Level", defaultMessage: "Level" }) + ' 1', color: theme.colors.positive200, value: 1 },
        { label: intl.formatMessage({ id: "Devices.Level", defaultMessage: "Level" }) + ' 2', color: theme.colors.positive, value: 2 },
        { label: intl.formatMessage({ id: "Devices.Level", defaultMessage: "Level" }) + ' 3', color: theme.colors.positive700, value: 3 },
    ]

    const { data, isLoading, isSuccess, error } = useGetByIdAndTimeQuery(
        {
            id: props.id,
            start: props.start.toUTCString(),
            end: props.end.toUTCString(),
            propertyName: 'isStep1',
            resourceGroupId: props.resourceGroupId
        })
    const { data: data2 } = useGetByIdAndTimeQuery(
        {
            id: props.id,
            start: props.start.toUTCString(),
            end: props.end.toUTCString(),
            propertyName: 'isStep2',
            resourceGroupId: props.resourceGroupId
        })
    const { data: data3 } = useGetByIdAndTimeQuery(
        {
            id: props.id,
            start: props.start.toUTCString(),
            end: props.end.toUTCString(),
            propertyName: 'isStep3',
            resourceGroupId: props.resourceGroupId
        })
    const { data: data4 } = useGetByIdAndTimeQuery(
        {
            id: props.id,
            start: props.start.toUTCString(),
            end: props.end.toUTCString(),
            propertyName: 'isOn',
            resourceGroupId: props.resourceGroupId
        })

    const combinedData = useMemo(() =>
        [...data?.filter(v => v.value === true).map(v => mapEventValue(v, 1)) ?? [],
        ...data2?.filter(v => v.value === true).map(v => mapEventValue(v, 2)) ?? [],
        ...data3?.filter(v => v.value === true).map(v => mapEventValue(v, 3)) ?? [],
        ...data4?.filter(v => v.value === false).map(v => mapEventValue(v, 0)) ?? []]
            .sort(sortByTimeStamp),
        [data, data2, data3]);
    const events = useMemo(() => mapItems(combinedData, props.start, props.end), [combinedData])

    const currentValue = props.isStep1 ? 1 : props.isStep2 ? 2 : props.isStep3 ? 3 : 0;
    return (
        <>
            <GenericTimeline currentValue={currentValue} labels={labels} data={events} start={props.start} end={props.end}></GenericTimeline>
            <GenericTimeseriesStatistics currentValue={currentValue}  labels={labels} data={events} start={props.start} end={props.end}></GenericTimeseriesStatistics>
        </>
    )
}


function mapEventValue(item: HistoricalDataItem, value: number) {
    const cpy = { ...item };
    cpy.value = value;
    return cpy;
}

function sortByTimeStamp(a: HistoricalDataItem, b: HistoricalDataItem) {
    return (new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime())
}

const mapItems = (data: HistoricalDataItem[], startDate: Date, endDate: Date) => {

    let result: TGenericTimelineEvent[] = [];
    for (let i = 0; i < data.length; i++) {
        if (i === 0)
            result.push({ startDate: startDate, endDate: new Date(data[i].timeStamp), value: data[i].value });

        let start = data[i].timeStamp;
        let end = i + 1 < data.length ? data[i + 1].timeStamp : endDate;
        result.push({ startDate: new Date(start), endDate: new Date(end), value: data[i].value });
    }

    return result;
}
